import { createSlice } from "@reduxjs/toolkit";
import { DownloadSummary } from "../Apis/DownloadSummary";

export const DownloadSummarySlice = createSlice({
  name: "downloadsummary",
  initialState: {
    downloadsummary: null,
    authenticatingdownloadsummary: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.downloadsummary = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingdownloadsummary = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(DownloadSummary.fulfilled, (state, action) => {
      state.downloadsummary = action.payload;
      state.authenticated = false;
      state.authenticatingdownloadsummary = false;
      return state;
    });
    builder.addCase(DownloadSummary.pending, (state, action) => {
      state.authenticatingdownloadsummary = true;
      state.authenticated = true;
    });
    builder.addCase(DownloadSummary.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingdownloadsummary = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = DownloadSummarySlice.actions;

export const DownloadSummarySelector = (state) => state.downloadsummary;
